<template>
  <div>
    <div class="checkbox-wrapper">
      <input type="checkbox" id="checkbox" v-model="model">
      <div
        class="checkbox only-on-large"
        :class="model ? 'active' : ''"
        @click="() => model = !model"
      >
        <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 5L5 9L13 1" stroke="white" stroke-width="2"/>
        </svg>
      </div>
      <div
        class="checkbox-mobile hide-on-large"
        :class="model ? 'active' : ''"
        @click="() => model = !model"
      >
        <div class="checkbox-mobile-inner-circle"/>
      </div>
      <label class="checkbox-label" for="checkbox">
        <slot />
      </label>
    </div>
    <div v-if="errorMessage" class="input-error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'commonCheckbox',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
    },
  },
  data: () => ({
    model: '',
  }),
  watch: {
    model(oldValue) {
      this.$emit('input', oldValue);
    },
  },
  mounted() {
    this.model = this.checked;
  },
};
</script>

<style lang="scss" scoped>
  .checkbox-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;

    label {
      cursor: pointer;
    }
  }

  #checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkbox {
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    border: 1px solid var(--primary);
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    &.active {
      background-color: var(--primary);
    }
  }

  .checkbox-label {
    @extend .small-regular;
    color: var(--gray-700);
  }

  @media (max-width: $breakpoint-large) {
    .checkbox-wrapper {
      flex-direction: row-reverse;
      justify-content: space-between;
      gap: 20px;
    }

    .checkbox-mobile {
      box-sizing: border-box;
      flex: 0 0 56px;
      height: 32px;
      border-radius: 16px;
      padding: 4px;
      background-color: var(--gray-300);
      position: relative;
      transition: all .2s linear;

      &.active {
        background-color: var(--primary);

        .checkbox-mobile-inner-circle {
          right: 4px;
        }
      }
    }

    .checkbox-mobile-inner-circle {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: var(--white);
      position: absolute;
      transition: all .2s linear;
      right: 28px;
    }

    .checkbox-label {
      font-size: 18px;
      line-height: 24px;
    }
  }
</style>
